import React from 'react';
import { motion } from 'framer-motion';
import { T, Lang } from '../lib/i18n';
export function PainSection({
  lang
}: {
  lang: Lang;
}) {
  const t = T[lang].pain;
  const cards = [{
    title: t.c1_title,
    desc: t.c1_desc
  }, {
    title: t.c2_title,
    desc: t.c2_desc
  }, {
    title: t.c3_title,
    desc: t.c3_desc
  }, {
    title: t.c4_title,
    desc: t.c4_desc
  }];
  return <section className="bg-brand-bg-subtle py-24 px-4 md:px-8" data-id="element-277">
      <div className="max-w-[1100px] mx-auto" data-id="element-278">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-279">
          <h2 className="font-display font-extrabold text-[clamp(1.8rem,4vw,2.8rem)] text-brand-navy-dark mb-4" data-id="element-280">
            {t.h2_1}
            <span className="text-red-500 italic" data-id="element-281">{t.h2_2}</span>
          </h2>
          <p className="text-brand-text-muted max-w-[500px] mx-auto text-lg" data-id="element-282">
            {t.subtitle}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-283">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-brand-blue-primary/10 rounded-[14px] p-7 relative overflow-hidden group hover:-translate-y-1 hover:border-brand-blue-primary/30 transition-all duration-300" data-id="element-284">
              <div className="absolute top-0 left-0 w-full h-[2px] bg-brand-blue-primary opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-285"></div>
              <h3 className="font-display font-bold text-lg text-brand-navy-dark mb-3" data-id="element-286">
                {card.title}
              </h3>
              <p className="text-brand-text-secondary text-sm leading-relaxed" data-id="element-287">
                {card.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-gradient-to-br from-brand-blue-primary/5 to-brand-gold-champagne/10 border border-brand-blue-primary/15 rounded-[16px] p-8 text-center" data-id="element-288">
          <p className="font-display font-bold text-[clamp(1.2rem,3vw,1.8rem)] text-brand-navy-dark" data-id="element-289">
            {t.sol_1}
            <span className="bg-gradient-brand bg-clip-text text-transparent" data-id="element-290">
              {t.sol_2}
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}